import { render } from "./DashboardOrders.vue?vue&type=template&id=794f50c1"
import script from "./DashboardOrders.vue?vue&type=script&lang=js"
export * from "./DashboardOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__